import { Component, Input, SimpleChange, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { KeyValuePair } from '../../../models/common/keyValuePair';
import { TripService } from '../../../services/trip.service';
import { TripContainerDto } from '../../../models/trips/tripContainer';

@Component({
	selector: 'ztsi-container-select',
	templateUrl: './ztsi-container-select.component.html',
	styleUrls: ['./ztsi-container-select.component.css'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ZtsiContainerSelectComponent),
			multi: true
		}
	]
})
export class ZtsiContainerSelectComponent implements ControlValueAccessor {
	containers: TripContainerDto[] = [];
	options: KeyValuePair[] = [];
	isLoading: boolean = false;
	
	@Input('value') _value: string;
	@Input() isDisabled: boolean = false;
	@Input() tripId: number;
	@Input() showAsLabel: boolean = false;
	@Input() containerStatus: string;

	constructor(
		private _tripService: TripService
	) { }

	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.onChange(val);
		this.onTouched();
	}

	writeValue(value): void {
		if (value !== undefined) {
			this._value = value;
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	ngOnInit() {
		this.loadSelection();
	}

	loadSelection() {
		if (this.tripId == null || this.tripId == undefined || isNaN(Number(this.tripId))) {
			this.options = [];
			return;
		}

		this.isLoading = true;
		// this._tripService.getContainersDropdownList(this.tripId).subscribe(response => {
		// 	if (response.length != undefined) {
		// 		this.containers = response;
		// 	}
		// 	else {
		// 		console.log('Unable to load container selection.');
		// 	}
		// 	this.isLoading = false;
		// });

		this._tripService.getContainersDropdownListV2(this.tripId).subscribe(response => {
			if (response.length != undefined) {
				this.containers = response;
				this.filterContainers();
			}
			else {
				console.log('Unable to load container selection.');
			}
			this.isLoading = false;
		});
	}

	filterContainers() {
		this.options = this.containers
			.filter(x => !this.containerStatus || x.status == this.containerStatus)
			.map(x => ({
				key: x.id,
				value: `${x.containerNumber} ${x.containerNumberTwo} (${x.containerSize}) => ${x.destination}`
			}));
	}

	ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
		if (changes.tripId != undefined) {
			this.tripId = changes.tripId.currentValue;
			this.loadSelection();
		}
		else if (changes.containerStatus != undefined) {
			this.filterContainers();
		}
	}

	getLabel() {
		if (this.value != undefined) {
			let item = this.options[this.options.findIndex(x => x.key == this.value)];
			return item == undefined ? '' : item.value;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-container-select/ztsi-container-select.component.ts